const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const ItemAcceptanceCancellationCommandURL: any = {
    ShotCancellationAdd: Backofficebff + '/v1/shotcancellation/add',
    ProductAcceptanceAdd: Backofficebff + '/v1/productacceptance/add',
    UploadImage: Backofficebff + '/v1/photo/add',
};
